import { render, staticRenderFns } from "./RequestSteps.vue?vue&type=template&id=612d160a&scoped=true&"
import script from "./RequestSteps.vue?vue&type=script&lang=js&"
export * from "./RequestSteps.vue?vue&type=script&lang=js&"
import style0 from "./RequestSteps.vue?vue&type=style&index=0&id=612d160a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612d160a",
  null
  
)

export default component.exports